module.exports = __webpack_public_path__ + "assetsclientes/img/logo.a1918669.svg";